import { create } from "zustand";

// when current running yer changes change in  isdisbaled also need to have same value 

export const useStore = create((set) => ({
    currentRunningYear:'2025',
    Collapsed: window.innerWidth >= 1000 ? false : true,
    setCollapsed: (collapsed: boolean) =>
        set((state: any) => ({ ...state, Collapsed: collapsed })),
    sideNavStatus:
        localStorage.getItem("main_status") == "client_review" ||
        localStorage.getItem("main_status") == "e_filing",
    setSidenavStatus: (collapsed: boolean) =>
        set((state: any) => ({ ...state, sideNavStatus: collapsed })),
    mainStatus: localStorage.getItem("main_status"),
    setmainStatus: (collapsed: any) =>
        set((state: any) => ({ ...state, mainStatus: collapsed })),
    setSelectedYear: (collapsed: any) =>
        set((state: any) => ({ ...state, SelectedYear: collapsed })),
    currentYear: new Date().getFullYear(),
    isDisabled:  '2025' != localStorage.getItem("selectedYear")
    ,

    setIsDisabled: (disable: boolean) =>
        set((state: any) => ({ ...state, isDisabled: disable })),
    SelectedYear:
        localStorage.getItem("selectedYear") || new Date().getFullYear(),
    // global control for showing the Refer a Friend modal
    showReferModal: false,
    setShowReferModal: (open: boolean) =>
        set((state: any) => ({ ...state, showReferModal: open })),
}));
